import React, { useEffect, useCallback, useState} from 'react';
import EffectOption from './EffectOption.js';
import Dropdown from 'react-dropdown';
import EffectComponent from 'components/effects/EffectComponent.js';
import Colors from 'components/Colors.js';
import SendEffect from '../../track/SendEffect.js';
import {effectOptions, getEffectOption, initializeEffect} from 'components/effects/constants.js';
import {connect} from 'react-redux';
import {
    setSelectedMixEffect,
} from 'actions/index.js';

const colors = new Colors();

const AudioEffects = ({
    currentSubSequence,
    selectedTrack,
    selectedGroup,
    sequencerEngine,
    selectedEffect,
    setSelectedEffect}) => { 
        let [value, setValue] = useState(undefined);
        let trackOrGroup = undefined;
        if (selectedTrack !== undefined) {
            trackOrGroup = sequencerEngine.tracks[selectedTrack];
        } else if (selectedGroup !== undefined) {
            trackOrGroup = sequencerEngine.groups.groups[selectedGroup];
        }

        let _track = sequencerEngine.tracks[selectedTrack];
        let _group = sequencerEngine.groups.groups[selectedGroup];

        let effects = trackOrGroup ? trackOrGroup.effects : [];

        const moveEffectTo = useCallback((from, to) => {
            trackOrGroup.moveEffectTo(from, to);
            setValue({from, to});
        }, [trackOrGroup, setValue]);

        const onDelete = useCallback(() => {
            setSelectedEffect(currentSubSequence, selectedTrack, selectedGroup, undefined);
        }, [currentSubSequence, selectedTrack, selectedGroup]);

        let fxComponent = '';
        if (selectedEffect && effects.some(e => e.id === selectedEffect.id)) {
            fxComponent = (
                <EffectComponent
                  sequencerEngine={sequencerEngine}
                  track={sequencerEngine.tracks[selectedTrack]}
                  group={sequencerEngine.groups.groups[selectedGroup]}
                  compact={true}
                  onDeleteEffect={() => onDelete()}
                  effect={selectedEffect}
                  send={undefined}/>);
        }

        const handleChooseEffect = useCallback((e) => {
            let effect = initializeEffect(e.value, sequencerEngine);
            effect.enable(true);
            if (effect.wetParameter) {
                effect.wetParameter.set(1);
            }
            trackOrGroup.effectsChain.addEffect(effect);
            setValue(e.value);
            return false;
        }, [setValue, sequencerEngine, trackOrGroup]);

        let name = "";
       if (_track) {
            name = _track.presetName || _track.getName();
        } else if (_group) {
            name = "Group " + (_group.groupNumber + 1);
        }

        let style = {
            backgroundColor: _track ? colors.getColorForTrack(_track) :
                _group ?
                colors.getColorForTrack(_group.tracks[0]) : 'black'
        };
        return (
            <div className="audio-effects">
              <div
                style={style}
                className="effects-channel-strip">
                <Dropdown
                  className='send-effects-dropdown'
                  options={effectOptions}
                  onChange={handleChooseEffect}
                  placeholder="Audio FX" />
                <div className="effects-list">
                  {effects.map(
                      (effect, i) =>
                          <EffectOption
                            key={effect.id}
                            track={selectedTrack}
                            group={selectedGroup}
                            currentSubSequence={currentSubSequence}
                            effectType={"AUDIO_FX"}
                            moveEffectTo={moveEffectTo}
                            effectNumber={i}
                            effect={effect}/>)}
                </div>
             </div>
              {fxComponent}
            </div>);
    }

const mapStateToProps = (state, props) => {
    let selectedTrack = state.mix.selectedGroup === undefined ?
            state.mix.selectedTrack : undefined;
    let selectedGroup = state.mix.selectedGroup;
    let subId = state.sequencer.currentSubSequence[props.sequencerEngine.engineId];
    return {
        selectedTrack, 
        selectedGroup,
        selectedEffect: selectedTrack !== undefined ? state.mix.selectedTrackEffects[subId] &&
            state.mix.selectedTrackEffects[subId][selectedTrack] :
            state.mix.selectedGroupEffects[subId] &&
            state.mix.selectedGroupEffects[subId][selectedGroup],
        currentSubSequence: state.sequencer.currentSubSequence[props.sequencerEngine.engineId],
    };
};

const mapDispatchToProps = (dispatch, props) => {
    return {
        setSelectedEffect: (sub, trackNumber, groupNumber, effect) => dispatch(
            setSelectedMixEffect(sub, trackNumber, groupNumber, "AUDIO_FX", effect))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AudioEffects);
